module.exports = __webpack_public_path__ + "static/img/3.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/3.jpg
// module id = wBqP
// module chunks = 0